import { frontendURL } from 'dashboard/helper/URLHelper.js';
import WhatsappGroupsLayout from './WhatsappGroupsLayout.vue';

const WhatsappGroupsDashboard = () => import('./WhatsappGroupsDashboard.vue');
const WhatsappGroupsList = () => import('./WhatsappGroupsList.vue');
const WhatsappGroupDetail = () => import('./WhatsappGroupDetail.vue');
const WhatsappMessages = () => import('./WhatsappMessages.vue');
const WhatsappCampaigns = () => import('./WhatsappCampaigns.vue');
const WhatsappCampaignDetail = () => import('./WhatsappCampaignDetail.vue');
const WhatsappWebhooks = () => import('./WhatsappWebhooks.vue');
const WhatsappActivities = () => import('./WhatsappActivities.vue');
const WhatsappLaunchLink = () => import('./WhatsappLaunchLink.vue');
const WhatsappSequences = () => import('./WhatsappSequences.vue');

// Módulo só de administrador (decisão 8): o backend das campanhas de grupo
// exige administrador, então um papel customizado não entra aqui.
const meta = {
  permissions: ['administrator'],
  featureFlag: 'whatsapp_groups',
};

const whatsappGroupsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/whatsapp-groups'),
      component: WhatsappGroupsLayout,
      children: [
        {
          path: '',
          name: 'whatsapp_groups_index',
          meta,
          redirect: to => ({
            name: 'whatsapp_groups_campaigns',
            params: { accountId: to.params.accountId },
          }),
        },
        {
          path: 'overview',
          name: 'whatsapp_groups_dashboard',
          meta,
          component: WhatsappGroupsDashboard,
        },
        {
          path: 'groups',
          name: 'whatsapp_groups_list',
          meta,
          component: WhatsappGroupsList,
        },
        {
          path: 'groups/:groupId',
          name: 'whatsapp_group_detail',
          meta,
          component: WhatsappGroupDetail,
          props: true,
        },
        {
          path: 'messages',
          name: 'whatsapp_groups_messages',
          meta,
          component: WhatsappMessages,
        },
        {
          path: 'sequences',
          name: 'whatsapp_groups_sequences',
          meta,
          component: WhatsappSequences,
        },
        {
          path: 'campaigns',
          name: 'whatsapp_groups_campaigns',
          meta,
          component: WhatsappCampaigns,
        },
        {
          path: 'campaigns/:campaignId',
          name: 'whatsapp_groups_campaign_detail',
          meta,
          component: WhatsappCampaignDetail,
          props: true,
        },
        {
          // Entrada automática: o controller inteiro é só de administrador,
          // então a rota também é (antes quem só lê via uma lista vazia).
          path: 'webhooks',
          name: 'whatsapp_groups_webhooks',
          meta: {
            ...meta,
            permissions: ['administrator'],
          },
          component: WhatsappWebhooks,
        },
        {
          path: 'activities',
          name: 'whatsapp_groups_activities',
          meta,
          component: WhatsappActivities,
        },
        {
          // Cockpit de Lançamento removed from Groups happy path — redirect to Campanhas
          path: 'launch-ops',
          name: 'whatsapp_groups_launch_ops',
          meta: {
            ...meta,
            permissions: ['administrator'],
          },
          redirect: to => ({
            name: 'whatsapp_groups_campaigns',
            params: { accountId: to.params.accountId },
            query: { notice: 'cockpit_removed' },
          }),
        },
        {
          // Deep link kept for power users / campaign detail; not in Mais nav
          path: 'launch-link',
          name: 'whatsapp_groups_launch_link',
          meta: {
            ...meta,
            permissions: ['administrator'],
          },
          component: WhatsappLaunchLink,
        },
      ],
    },
  ],
};

export default whatsappGroupsRoutes;
